import React, { useState, useEffect, useContext } from "react";
import AuthContext from "../../Context/AuthContext";
import Container from "react-bootstrap/Container";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import Form from "react-bootstrap/Form";
import Spinner from "react-bootstrap/Spinner";
import axios from "axios";
import ObjectivePeopleList from "../Components/ObjectivePeopleList";
import { useTranslation } from "react-i18next";
import "./Objectives.css";

function Objectives() {
  const [isLoading, setIsLoading] = useState(true);
  const [people, setPeople] = useState([]);
  const [filter, setFilter] = useState("");
  const [categories, setCategories] = useState([]);

  const { state } = useContext(AuthContext);

  const { t } = useTranslation();

  useEffect(() => {
    async function fetch() {
      const response = await axios({
        method: "post",
        url: `${process.env.REACT_APP_BACKEND_URL}/objectives/users/organization/${state.organization}`,
        data: {
          filter: filter,
        },
        headers: {
          Authorization: `Bearer ${state.token}`,
        },
      });
      setPeople(response.data.users);
      if (state.language === "es") {
        setCategories(
          response.data.categories.sort((a, b) => (a.name > b.name ? 1 : -1)),
        );
      } else if (state.language === "en") {
        setCategories(
          response.data.categories.sort((a, b) =>
            a.name_english > b.name_english ? 1 : -1,
          ),
        );
      }

      setIsLoading(false);
    }
    fetch();
  }, [filter, state.organization, state.token, state.language]);

  if (isLoading === true) {
    return (
      <Spinner animation="border" role="status">
        <span className="visually-hidden">Loading...</span>
      </Spinner>
    );
  } else {
    return (
      <Container fluid>
        <Row className="align-items-center">
          <Col className="objectives-header">
            <h2>{t("Objetivos.Titulo")}</h2>
          </Col>
        </Row>
        <Row>
          <Col>
            <Form.Group className="mb-3">
              <Form.Select
                className="mb-3"
                name="categories"
                onChange={(e) => setFilter(e.target.value)}
                value={filter}
              >
                <option value={""}>{t("Reportes.Filtar")}</option>
                {categories.map((item) => (
                  <option key={item._id} id={item._id} value={item._id}>
                    {state.language === "es" ? item.name : item.name_english}
                  </option>
                ))}
              </Form.Select>
            </Form.Group>
          </Col>
        </Row>
        <Row className="align-items-center">
          {people.length === 0 ? (
            <Col className="empty-objectives center">
              <h5>{t("Objetivos.SinObjetivos")}</h5>
            </Col>
          ) : (
            <ObjectivePeopleList people={people} language={state.language} />
          )}
        </Row>
      </Container>
    );
  }
}

export default Objectives;
